module.exports = __webpack_public_path__ + "static/media/hood-cloak.1a5a9f3a.svg";